import React from 'react';
import { Box, Divider, Menu, MenuItem } from '@mui/material';
import Icon from '@mdi/react';
import RibbonMenuButton from '../RibbonMenuButton';
import RibbonMenuExpandMoreButton from './RibbonMenuExpandMoreButton';
import styles from './RibbonMenuGroup.module.scss';
import RibbonButtonSize from '../RibbonButtonSize';
import { concatClassNames } from '../../../../utils';

export default (props: IRibbonMenuGroupProps) => {
    const chevronBtnRef = React.useRef<HTMLButtonElement>(null);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const handleClick = (_event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(chevronBtnRef.current);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const menuElements: JSX.Element[] = [];
    const dividerKey = () => {
        return `divider-${Math.floor(Math.random() * 10000)}`;
    };

    if (!props.menu) {
        return <>empty!</>;
    }

    props.menu.forEach((group, idx) => {
        if (idx > 0) {
            menuElements.push(<Divider key={dividerKey()} sx={{ my: 0.5 }} />);
        }
        if (Array.isArray(group)) {
            return group.forEach(x => {
                if (Array.isArray(x)) {
                    menuElements.push(<Divider key={dividerKey()} sx={{ my: 0.5 }} />);
                    x.forEach(y => {
                        menuElements.push(
                            <MenuItem
                                className={styles.menuItem}
                                disabled={!y.config.Enabled}
                                key={y.config.GetUniqueKey()}
                                onClick={() => {
                                    y.config.Callback();
                                    setAnchorEl(null);
                                }}
                            >
                                {y.config.GetIcon()}
                                {y.config.GetTitle()}
                            </MenuItem>,
                        );
                    });
                } else if (Array.isArray(x.config)) {
                    x.config.forEach(y => {
                        menuElements.push(
                            <MenuItem
                                className={styles.menuItem}
                                disabled={!y.Enabled}
                                key={y.GetUniqueKey()}
                                onClick={() => {
                                    y.Callback();
                                    setAnchorEl(null);
                                }}
                            >
                                {y.GetIcon()}
                                {y.GetTitle()}
                            </MenuItem>,
                        );
                    });
                } else {
                    menuElements.push(
                        <MenuItem
                            className={styles.menuItem}
                            disabled={!x.config.Enabled}
                            key={x.config.GetUniqueKey()}
                            onClick={() => {
                                x.config.Callback();
                                setAnchorEl(null);
                            }}
                        >
                            {x.config.GetIcon()}
                            {x.config.GetTitle()}
                        </MenuItem>,
                    );
                }
            });
        }
        menuElements.push(
            <MenuItem
                className={styles.menuItem}
                disabled={!group.config.Enabled}
                key={group.config.GetUniqueKey()}
                value={group.config.Value}
                onClick={() => {
                    group.config.Callback();
                    setAnchorEl(null);
                }}
            >
                {group.config.Path && group.config.Path !== false && (
                    <Icon path={group.config.Path} />
                )}
                {group.config.GetIcon()}
                {group.config.GetTitle()}
            </MenuItem>,
        );
    });

    return (
        <>
            <Box className={concatClassNames(props.className, styles.buttonGroup, 'ribbonMenuGroupBox')}>
                <RibbonMenuButton
                    key={`btn${props.button.config.Key}`}
                    config={{
                        ...props.button.config,
                        Callback: props.button.config.OpenContextMenu
                            ? handleClick
                            : props.button.config.Callback,
                    }}
                    size={props.button.size}
                />
                <RibbonMenuExpandMoreButton
                    ref={chevronBtnRef}
                    key={`dropdownMenu${props.button.config.Key}`}
                    config={{
                        ...props.button.config,
                        Callback: handleClick,
                    }}
                    size={RibbonButtonSize.DropDown}
                />
            </Box>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {menuElements}
            </Menu>
        </>
    );
};

interface IRibbonMenuGroupProps {
    className?: string;
    // TODO: Data Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    button: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    menu: any[];
}
